import { Vue, MsgBox } from '../../app.vues'
import { Utils } from '../../app.base'

import SwbDevcClassifyTagListSelect from './DevcClassifyTagListSelect';
Vue.regist(SwbDevcClassifyTagListSelect);

import SwbDevcCustInfoSave from './DevcCustInfoSave';
Vue.regist(SwbDevcCustInfoSave);

export function showDevcClassifyTagListSelectDlg(callback) {
    let theDlg = Vue.$showDialog({
        title: "归类标签选择",
        width: 900,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<div><swb-devc-classify-tag-list-select ref="swb_select"></swb-devc-classify-tag-list-select></div>',
        data: {},
        okClicked: function () {
            let dlgResult = this.$refs.swb_select.getDlgResult() || {};
            if(dlgResult.type == 'info') {
                callback(dlgResult.data);
                return true;
            } else {
                MsgBox.warning(dlgResult.message);
            }
            return false;
        }
    });
};

export function showDevcCustInfoSaveDlg(devcId, callback) {
    let theDlg = Vue.$showDialog({
        title: "设备自定义信息",
        width: 500,
        height: 800,
        cancelVisible: true,
        okVisible: true,
        template: '<div><swb-devc-cust-info-save :devcId="devcId" :viewMode="viewMode" ref="swb_select"></swb-devc-cust-info-save></div>',
        data: {
            devcId: devcId,
            viewMode: false
        },
        okClicked: function () {
            let dlgResult = this.$refs.swb_select.getDlgResult() || {};
            if(dlgResult.type == 'info') {
                callback(dlgResult.data);
                return true;
            }
            return false;
        }
    });
};

//简单java类型
export function getSimpleJavaTypes() {
    return ['String', 'Long', 'Double', 'Date', 'Boolean'];
}

//简单java类型name => text
export function getSimpleJavaTypesMap() {
    return {
        'String': '字符串',
        'Long': '整数',
        'Double': '小数',
        'Date': '日期',
        'Boolean': '布尔（是否）',
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/devcCust/selectDlg.js
// module id = 129
// module chunks = 0